// src/components/LazyGtagLoader.js
import { useEffect } from "react";

const LazyGtagLoader = () => {
  useEffect(() => {
    const loadGtag = () => {
      if (window.gtagLoaded) return;

      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_TRACKING_ID}`;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", process.env.GATSBY_GA_TRACKING_ID);
        window.gtagLoaded = true;
      };
    };

    const triggerEvents = ["scroll", "mousemove", "click", "touchstart"];
    triggerEvents.forEach((event) =>
      window.addEventListener(event, loadGtag, { once: true })
    );

    return () => {
      triggerEvents.forEach((event) =>
        window.removeEventListener(event, loadGtag)
      );
    };
  }, []);

  return null;
};

export default LazyGtagLoader;
